import './AppLoadingScreen.css';

interface AppLoadingScreenProps {
  variant: 'auth' | 'drive';
}

export function AppLoadingScreen({ variant }: AppLoadingScreenProps) {
  return (
    <div className="app-loading-screen">
      <div className="app-loading-logo">bigwa.</div>
      {variant === 'drive' && (
        <p className="app-loading-message">Preparando sua Mesa. Aguarde.</p>
      )}
      <div className="app-loading-dots">
        <span className="app-loading-dot" />
        <span className="app-loading-dot" />
        <span className="app-loading-dot" />
      </div>
    </div>
  );
}
